import {Component, OnInit} from '@angular/core';
import {ApiService} from "../service/api.service";
import {isEmpty} from "sdv-common";

@Component({
  selector: 'app-ooops',
  templateUrl: './ooops.component.html',
  styleUrls: ['./ooops.component.scss']
})
export class OoopsComponent implements OnInit {

  constructor(public apiService: ApiService) {
  }

  ngOnInit() {
  }

  protected readonly isEmpty = isEmpty;
}
